import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface GetDefaultIdentityPoolDescriptionParams {
}

export class GetDefaultIdentityPoolDescriptionRequest extends Request<GetDefaultIdentityPoolDescriptionParams, IResult> {
  constructor(params: GetDefaultIdentityPoolDescriptionParams = {}) {
    super('getDefaultIdentityPoolDescription', params);
  }
}